import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import React, { useContext } from 'react';
import { DatePicker } from '../../../../base/Forms/DatePicker';
import { ComissaoContext } from '../../../../providers/Comissao';
import { Loading } from '../../../../ui/Loading';
import { useStyles } from '../../style';
import { SelectComissao } from '../SelectComissao';

interface IFormBonusConversao {
  loading: boolean;
  fetchData: any;
  setCurrentPage: any;
}

export const FormBonusConversao = ({
  loading,
  fetchData,
  setCurrentPage,
}: IFormBonusConversao) => {
  const classes = useStyles();
  var {
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal,
    searchField,
    setSearchField,
    searchText,
    setSearchText,
  } = useContext(ComissaoContext);
  return (
    <>
      <Grid container spacing={3}>
        <Grid container item xs={12} md={8}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              <SelectComissao loading={loading} />
            </Grid>

            <Grid item xs={12} lg={4}>
              <FormControl fullWidth>
                <DatePicker
                  fullWidth
                  disabled={loading}
                  required
                  disableToolbar
                  name="dataInicial"
                  variant="inline"
                  id="DataInicial"
                  autoComplete="DataInicial"
                  label="Data de Pagamento Inicial"
                  value={dataInicial}
                  onChange={(date: Date | null) => setDataInicial(date)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={4}>
              <FormControl fullWidth>
                <DatePicker
                  fullWidth
                  disabled={loading}
                  required
                  disableToolbar
                  name="dataFinal"
                  variant="inline"
                  label="Data de Pagamento Final"
                  id="DataFinal"
                  value={dataFinal}
                  onChange={(date: Date | null) => setDataFinal(date)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={4}>
              <FormControl fullWidth>
                <InputLabel id="Filtro" required>
                  Filtrar por
                </InputLabel>

                <Select
                  disabled={loading}
                  required
                  labelId="Filtro"
                  id="SelectFiltro"
                  value={searchField}
                  onChange={(e) => setSearchField(e.target.value as string)}
                >
                  <MenuItem value={' '}>Sem Filtro</MenuItem>
                  <MenuItem value={'contrato'}>Nr. Contrato</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {searchField === 'contrato' && (
              <Grid item xs={12} lg={4}>
                <FormControl fullWidth>
                  <TextField
                    disabled={loading}
                    name="searchText"
                    label="Busca"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          md={4}
          spacing={3}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
          }}
        >
          <Button
            disabled={loading}
            type="submit"
            variant="contained"
            color="primary"
            onClick={() => {
              setCurrentPage(1);
              fetchData(0, true);
            }}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
      <div className={classes.loadingContainer}>
        <Loading loading={loading} />
      </div>
    </>
  );
};
